export class Filter {
  obveznik: string;
  zona: string;
  ulica: string;
}
